import Tracking from "shared/src/uidispatcherapi/Tracking";

export function locationChanged(
    oldLocation: {
        [x: string]: any;
    },
    newLocation: {
        [x: string]: any;
    },
    pageName: string | undefined | null
) {
    if (!oldLocation || !newLocation) {
        const sanitizedName = pageName ? pageName : "unknown";
        Tracking.trackError(
            "searchdiscover",
            "ui",
            "PageTrackingUtil",
            "The page has no location object. But it should have. Please adjust page '" + sanitizedName + "'!"
        );
        return false;
    }
    if (oldLocation.href && newLocation.href) {
        return oldLocation.href !== newLocation.href;
    }
    return oldLocation.pathname !== newLocation.pathname || oldLocation.search !== newLocation.search;
}
